module.exports = __webpack_public_path__ + "img/1547173473.b37833df.jpg";